module.exports = __webpack_public_path__ + "media/images/icons/outlined/smile-6ed527acfdb243c0db5af720829abdfe.svg";